<template>
	<Badge
		v-if="isColor"
		:color="status"
		:text="text"
	/>
	<Badge
		v-else
		:status="status"
		:text="text"
	/>
</template>

<script>
import { computed, toRef } from 'vue';
import { Badge } from 'ant-design-vue';

export default {
	components: {
		Badge,
	},
	props: {
		status: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			default: '',
		},
	},
	setup(props) {
		const statusRef = toRef(props, 'status');
		const isColor = computed(() => statusRef.value.startsWith('#'));

		return {
			isColor,
		};
	},
}
</script>
